import router from '../../router/index';
import axios from "axios";
export const state = {
    expense_categories: [],
    expenses_cart: [],
    expenses: [],
    creditors: [],
    expense_report: [],
    expense_save_status: false,
    filter_status: false,
    agentexpenses: [],
    expense_id: "",
};
export const getters = {
    ExpenseCategories: state => state.expense_categories.data,
    ExpensesCart: state => state.expenses_cart.data,
    Expenses: state => state.expenses.data,
    ExpenseSaveStatus: state => state.expense_save_status,
    filterStatus: state => state.filter_status,
    AgentExpenses: state => state.agentexpenses.data,
    Creditors: state => state.creditors.data,
    ExpenseId: state => state.expense_id,



};

export const mutations = {
    SET_EXPENSE_CATEGORIES(state, newValue) {
        state.expense_categories = newValue
    },

    SET_EXPENSES_CART(state, newValue) {
        state.expenses_cart = newValue
    },
    SET_EXPENSES(state, newValue) {
        state.expenses = newValue
    },
    SET_EXPENSE_STATUS(state, newValue) {
        state.expense_save_status = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_AGENT_EXPENSES(state, newValue) {
        state.agentexpenses = newValue
    },
    SET_CREDITORS(state, newValue) {
        state.creditors = newValue
    },
    SET_EXPENSE_ID(state, newValue) {
        state.expense_id = newValue
    },
};

export const actions = {
    addExpenseCategory({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_EXPENSE_STATUS', true);
        axios.post('expense_categories', payload).then(() => {
            dispatch('fetchExpenseCategories');
            let message = { 'msg': "Expense Category added successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Adding Category" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit expense category
    editExpenseCategory({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.put(`expense_categories/${payload.id}`, payload).then(() => {
            dispatch('fetchExpenseCategories');
            let message = { 'msg': "Expense Category updated successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error updating Category" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete expense category
    deleteExpenseCategory({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_EXPENSE_STATUS', true);
        axios.delete(`expense_categories/${payload.id}`).then(() => {
            dispatch('fetchExpenseCategories');
            let message = { 'msg': "Expense Category deleted successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error deleting Category" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add expenditure
    recordExpense({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.post('expenses', payload).then(() => {
            dispatch('fetchExpensesCart');
            let message = { 'msg': "Expense added successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Adding Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },
    recordExpensePrint({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.post('expenses', payload).then((res) => {
            if (res.data && res.data.status === 200) {
                dispatch('fetchExpensesCart');

                commit('SET_EXPENSE_ID', res.data.id);
                // let message = { 'msg': "Expense added successfully" }
                //  dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': "Failed to record Expense" };
                dispatch('notification/error', message, { root: true });
            }

            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Adding Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },


    // Edit expense
    editExpenses({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.put(`expenses/${payload.id}`, payload).then(() => {
            dispatch('fetchExpenses');
            // let message = { 'msg': "Expense updated successfully" }
            // dispatch('notification/success', message, { root: true })
            router.push('/expenses/record').catch(() => {});
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error updating Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete expense 
    deleteExpense({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.delete(`expenses/${payload.id}`).then(() => {
            dispatch('fetchExpenses');
            let message = { 'msg': "Expenditure deleted successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Deleting Expenditure" }
            dispatch('notification/error', message, { root: true })
        })
    },


    // Expenses cart

    addExpenseCart({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.post('expense_cart', payload).then(() => {
            dispatch('fetchExpensesCart');
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Adding Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit cart
    editExpenseCart({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.put(`expense_cart/${payload.id}`, payload).then(() => {
            dispatch('fetchExpensesCart');
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error updating Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete cart
    deleteExpenseCart({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.delete(`expense_cart/${payload.id}`).then(() => {
            dispatch('fetchExpensesCart');
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Deleting Expenditure" }
            dispatch('notification/error', message, { root: true })
        })
    },


    fetchExpenseCategories({ commit }) {
        axios.get('expense_categories').then(ec_res => {
            commit('SET_EXPENSE_CATEGORIES', ec_res.data)
        })
    },

    fetchExpensesCart({ commit }) {
        axios.get('expense_cart').then(e_res => {
            commit('SET_EXPENSES_CART', e_res.data)
        })
    },
    fetchExpenses({ commit }) {
        axios.get('expenses').then(e_res => {
            commit('SET_EXPENSES', e_res.data)
        })
    },

    fetchExpensesReport({ commit }, payload) {
        commit('SET_FILTER_STATUS', true);
        axios.post('expenses_report', payload).then(e_res => {
            commit('SET_FILTER_STATUS', false);
            commit('SET_EXPENSES', e_res.data)
        })
    },

    fetchExpenseDetails({ commit }, id) {
        commit('SET_FILTER_STATUS', true);
        axios.put(`expenses_details/${id}`).then(e_res => {
            commit('SET_FILTER_STATUS', false);
            commit('SET_EXPENSES', e_res.data)
        })
    },

    // Agent Expenses
    fetchAgentExpenses({ commit }) {
        axios.get('allagentexpenses').then(e_res => {
            commit('SET_AGENT_EXPENSES', e_res.data)
        })
    },

    // Reject expense 
    rejectExpense({ commit, dispatch }, id) {
        commit('SET_EXPENSE_STATUS', true);
        axios.post(`reject_expenses/${id}`).then(() => {
            dispatch('fetchAgentExpenses');
            let message = { 'msg': "Expenditure rejected successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Rejecting Expenditure" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Confirm expense 
    confirmExpense({ commit, dispatch }, id) {
        commit('SET_EXPENSE_STATUS', true);
        axios.post(`confirm_expenses/${id}`).then(() => {
            dispatch('fetchAgentExpenses');
            let message = { 'msg': "Expenditure confirmed successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Confirming Expenditure" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add agent expenditure
    recordAgentExpense({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_EXPENSE_STATUS', true);
        axios.post('add_agentexpenses', payload).then(() => {
            dispatch('fetchAgentExpenses');
            let message = { 'msg': "Expense added successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Adding Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit agent expense
    editAgentExpenses({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.put(`edit_agentexpenses/${payload.id}`, payload).then(() => {
            dispatch('fetchAgentExpenses');
            let message = { 'msg': "Expense updated successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error updating Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete agent expense 
    deleteAgentExpense({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.delete(`deleted_agentexpenses/${payload.id}`).then(() => {
            dispatch('fetchAgentExpenses');
            let message = { 'msg': "Expenditure deleted successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Deleting Expenditure" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // creditors
    // Clear credit
    ClearCredit({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.put(`pay_expense_credit/${payload.id}`, payload).then(() => {
            let message = { 'msg': `Credit of ${payload.paid} Cleared successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_EXPENSE_STATUS', false);
            dispatch('fetchCreditors');

        }).catch(() => {
            commit('SET_EXPENSE_STATUS', false)
            let message = { 'msg': "Error Clearing Credit" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Clear credit
    ClearCreditPrint({ commit, dispatch }, payload) {
        commit('SET_EXPENSE_STATUS', true);
        axios.put(`pay_expense_credit/${payload.id}`, payload).then((res) => {

            if (res.data && res.data.status === 200) {
                commit('SET_EXPENSE_ID', res.data.id);
            } else {
                let message = { 'msg': "Failed to record Payment" };
                dispatch('notification/error', message, { root: true });
            }
            commit('SET_EXPENSE_STATUS', false);
        }).catch(() => {
            // console.error("Error:", error); 
            commit('SET_EXPENSE_STATUS', false);
            let message = { 'msg': "Error Clearing Credit" };
            dispatch('notification/error', message, { root: true });
        });
    },
    fetchCreditors({ commit }, payload) {
        commit('SET_FILTER_STATUS', true)
        axios.post('expense_creditors', payload).then(total => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_CREDITORS', total.data)
        })
    },

};